import React from 'react';
import styled from '@emotion/styled';

import { GetPdpIntegratedData_pdp_base_info_epick_list as Epick } from '@domains/pdp-common';

import { EpickStylistCarousel } from './Carousel';
import { EpickStylistHeader } from './Header';

export interface EpikStylistProps {
  className?: string;
  isApp: boolean;
  list: Epick[];
  onClickItemCard: (post_id: string, landing_url: string) => void;
  onImpressionItemCard: (post_id: string) => void;
}

export const EpikStylist: React.FC<React.PropsWithChildren<EpikStylistProps>> = ({
  className,
  isApp,
  list,
  onClickItemCard,
  onImpressionItemCard,
}) => {
  return (
    <EpickWrap className={className}>
      <EpickStylistHeader />
      <EpickStylistCarousel
        isApp={isApp}
        list={list}
        onClickItemCard={onClickItemCard}
        onImpressionItemCard={onImpressionItemCard}
      />
    </EpickWrap>
  );
};

const EpickWrap = styled.div`
  padding: 0 16px 24px 16px;
`;
